<h1 mat-dialog-title>
	<mat-dialog-actions align="end">
		<button
			class="mat-custom-button"
			color="primary"
			mat-raised-button
			*ngIf="payments.length !== 0"
			(click)="save()"
		>
			Zapisz
			<i class="ms-1 fa-regular fa-floppy-disk"></i>
		</button>
		<button class="mat-custom-button" mat-raised-button (click)="onNoClick()">
			Odrzuć
			<i class="ms-1 fa-regular fa-circle-xmark"></i>
		</button>
	</mat-dialog-actions>
</h1>

<form [formGroup]="form">
	<table class="mat-elevation-z4 mat-table mb-4">
		<tr class="mat-row">
			<td class="mat-cell pe-4">Konto oskara</td>
			<td class="mat-cell">
				<mat-form-field class="example-full-width">
					<input
						type="text"
						matInput
						formControlName="bankAccountPosting"
						[matAutocomplete]="auto"
						required
					/>
					<mat-hint
						class="text-danger"
						*ngIf="
							(form.controls.bankAccountPosting.touched || submitted) &&
							form.controls.bankAccountPosting.errors?.required
						"
						>Uzupełnij konto</mat-hint
					>
					<mat-autocomplete
						#auto="matAutocomplete"
						[displayWith]="displayFn.bind(this)"
						(optionSelected)="selectOption($event)"
					>
						<mat-option *ngFor="let item of filteredBankAccountPosting" [value]="item.id">
							{{ item.organization?.shortName }} {{ item.number }}
						</mat-option>
					</mat-autocomplete>
				</mat-form-field>
			</td>
		</tr>
		<tr class="mat-row">
			<td class="mat-cell pe-4">Data księgowania</td>
			<td class="mat-cell">
				<mat-form-field class="w-100 me-2">
					<input matInput required formControlName="posting" [matDatepicker]="posting" />
					<mat-hint
						class="text-danger"
						*ngIf="(form.controls.posting.touched || submitted) && form.controls.posting.errors?.required"
						>Uzupełnij datę księgowania</mat-hint
					>
					<mat-datepicker-toggle matSuffix [for]="posting"></mat-datepicker-toggle>
					<mat-datepicker #posting> </mat-datepicker>
				</mat-form-field>
			</td>
		</tr>
	</table>

	<ng-container formArrayName="payments">
		<mat-table #dataTable [dataSource]="payments.controls" class="mat-elevation-z4">
			<ng-container matColumnDef="tableId">
				<mat-header-cell *matHeaderCellDef> Numer rezerwacji </mat-header-cell>
				<mat-cell *matCellDef="let element; let i = index" [formGroup]="element"
					><mat-form-field>
						<input
							type="text"
							controls
							matInput
							required
							formControlName="tableId"
							[matAutocomplete]="auto"
						/>
						<mat-hint
							class="text-danger"
							*ngIf="
								(paymentsControl.controls[i].get('tableId').touched || submitted) &&
								paymentsControl.controls[i].get('tableId').errors?.required
							"
							>Uzupełnij numer rezerwacji</mat-hint
						>
						<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayReservationObj.bind(this)">
							<mat-option *ngFor="let item of reservationObj" [value]="item.id">
								{{ item.id }} | {{ item.ownerUser.firstName }}
								{{ item.ownerUser.lastName }}
							</mat-option>
						</mat-autocomplete>
					</mat-form-field>
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="userData">
				<mat-header-cell *matHeaderCellDef>
					Kto wpłaca
					<div class="add-header-button">
						<button (click)="changeOwner()" mat-raised-button class="mat-custom-button">
							<span>Dodaj</span>
						</button>
					</div>
				</mat-header-cell>
				<mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
					<mat-form-field class="example-full-width">
						<input type="text" matInput required formControlName="userData" [matAutocomplete]="auto" />
						<mat-hint
							class="text-danger"
							*ngIf="
								(paymentsControl.controls[i].get('userData').touched || submitted) &&
								paymentsControl.controls[i].get('userData').errors?.required
							"
							>Uzupełnij wpłącającego</mat-hint
						>
						<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayUserProfile.bind(this)">
							<mat-option *ngFor="let item of filteredUsers" [value]="item.id">
								{{ item.firstName }} {{ item.lastName }}
							</mat-option>
						</mat-autocomplete>
					</mat-form-field>
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="amount">
				<mat-header-cell *matHeaderCellDef> Kwota </mat-header-cell>
				<mat-cell *matCellDef="let element; let i = index" [formGroup]="element"
					><mat-form-field>
						<input matInput type="number" required formControlName="amount" />
						<mat-hint
							class="text-danger"
							*ngIf="
								(paymentsControl.controls[i].get('amount').touched || submitted) &&
								paymentsControl.controls[i].get('amount').errors?.required
							"
							>Uzupełnij kwotę płatności</mat-hint
						>
					</mat-form-field></mat-cell
				>
			</ng-container>
			<ng-container matColumnDef="payment">
				<mat-header-cell *matHeaderCellDef> Data wpłaty </mat-header-cell>
				<mat-cell *matCellDef="let element; let i = index" [formGroup]="element"
					><mat-form-field class="w-100 me-2">
						<input matInput formControlName="payment" [matDatepicker]="payment" />
						<mat-hint
							class="text-danger"
							*ngIf="
								(paymentsControl.controls[i].get('payment').touched || submitted) &&
								paymentsControl.controls[i].get('payment').errors?.required
							"
							>Uzupełnij datę wpłaty</mat-hint
						>
						<mat-datepicker-toggle matSuffix required [for]="payment"></mat-datepicker-toggle>
						<mat-datepicker #payment> </mat-datepicker> </mat-form-field
				></mat-cell>
			</ng-container>
			<ng-container matColumnDef="bankAccountIncoming">
				<mat-header-cell *matHeaderCellDef> Konto klienta </mat-header-cell>
				<mat-cell *matCellDef="let element; let i = index" [formGroup]="element"
					><mat-form-field>
						<input matInput formControlName="bankAccountIncoming" />
						<mat-hint
							class="text-danger"
							*ngIf="
								(paymentsControl.controls[i].get('bankAccountIncoming').touched || submitted) &&
								paymentsControl.controls[i].get('bankAccountIncoming').errors?.required
							"
							>Uzupełnij konto klienta</mat-hint
						>
					</mat-form-field></mat-cell
				>
			</ng-container>
			<ng-container matColumnDef="invoiceNumber">
				<mat-header-cell *matHeaderCellDef> Nr faktury </mat-header-cell>
				<mat-cell *matCellDef="let element" [formGroup]="element"
					><mat-form-field> <input matInput formControlName="invoiceNumber" /> </mat-form-field
				></mat-cell>
			</ng-container>
			<ng-container matColumnDef="note">
				<mat-header-cell *matHeaderCellDef> Uwagi </mat-header-cell>
				<mat-cell *matCellDef="let element" [formGroup]="element"
					><mat-form-field> <input matInput formControlName="note" /> </mat-form-field
				></mat-cell>
			</ng-container>
			<ng-container matColumnDef="delete">
				<mat-header-cell *matHeaderCellDef></mat-header-cell>
				<mat-cell *matCellDef="let element; let i = index"
					><button class="mat-custom-delete-button" mat-raised-button (click)="removeRow(i)">
						Usuń<i class="ms-1 fa-solid fa-trash-can"></i></button
				></mat-cell>
			</ng-container>
			<mat-header-row class="mat-header-custom" *matHeaderRowDef="showColumns"></mat-header-row>
			<mat-row
				*matRowDef="let row; columns: showColumns; let key = index"
				[ngClass]="{ second: !(key % 2) }"
			></mat-row>
		</mat-table>
	</ng-container>
</form>

<mat-dialog-actions align="end">
	<button class="mat-custom-button" mat-raised-button (click)="addPos()">
		Dodaj pozycje<i class="ms-1 fa-solid fa-plus"></i>
	</button>
</mat-dialog-actions>
